import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  fetchFeedbackListFailure,
  fetchFeedbackListSuccess,
  //
  submitFeedbackFailure,
  submitFeedbackSuccess,
  //
  updateFeedbackFailure,
  updateFeedbackSuccess,
  //
  updateFeedbackStatusFailure,
  updateFeedbackStatusSuccess,
} from "./actions";
import {
  FETCH_FEEDBACK_LIST,
  SUBMIT_FEEDBACK,
  UPDATE_FEEDBACK,
  UPDATE_FEEDBACK_STATUS,
} from "./constants";

export function* fetchFeedbackListSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/feedback?${query}`);
    yield put(fetchFeedbackListSuccess(data));
  } catch (e) {
    yield put(fetchFeedbackListFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching feedback list!"));
  }
}

export function* submitFeedbackSaga({ payload, onDone }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).post, `/api/feedback`, payload);
    if (data) {
      yield put(submitFeedbackSuccess(data));
      yield put(successAlert("Thanks — your feedback has been sent."));
      typeof onDone === "function" && onDone(data);
    }
  } catch (e) {
    yield put(submitFeedbackFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* updateFeedbackSaga({ payload, onDone }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { uuid, ...body } = payload;
  try {
    const { data } = yield call(api(token).put, `/api/feedback/${uuid}`, body);
    if (data) {
      yield put(updateFeedbackSuccess(data));
      yield put(successAlert("Feedback updated."));
      typeof onDone === "function" && onDone(data);
    }
  } catch (e) {
    yield put(updateFeedbackFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* updateFeedbackStatusSaga({ payload, onDone }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { uuid, ...body } = payload;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/feedback/${uuid}/status`,
      body,
    );
    if (data) {
      yield put(updateFeedbackStatusSuccess(data));
      yield put(successAlert("Status updated."));
      typeof onDone === "function" && onDone(data);
    }
  } catch (e) {
    yield put(updateFeedbackStatusFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchFeedbackListFlow() {
  yield takeEvery(FETCH_FEEDBACK_LIST, fetchFeedbackListSaga);
}
export function* submitFeedbackFlow() {
  yield takeEvery(SUBMIT_FEEDBACK, submitFeedbackSaga);
}
export function* updateFeedbackFlow() {
  yield takeEvery(UPDATE_FEEDBACK, updateFeedbackSaga);
}
export function* updateFeedbackStatusFlow() {
  yield takeEvery(UPDATE_FEEDBACK_STATUS, updateFeedbackStatusSaga);
}

export default function* FeedbackSaga() {
  yield all([
    fetchFeedbackListFlow(),
    submitFeedbackFlow(),
    updateFeedbackFlow(),
    updateFeedbackStatusFlow(),
  ]);
}
